// 统计、SEO自动推送相关脚本，只在生产环境引入
if (process.env.VUE_APP_LOGIN_ENV === 'prod') {
  window.onload = function() {
    const _hmt = window._hmt || []
    _hmt.push([
      '_requirePlugin',
      'UrlChangeTracker',
      {
        shouldTrackUrlChange: function(newPath, oldPath) {
          return newPath && oldPath
        }
      }
    ])
    function addScriptToBody(url) {
      const script = document.createElement('script')
      script.src = url
      document.body.appendChild(script)
    }
    addScriptToBody('//hm.baidu.com/hm.js?8dc4c514c04c4ea290ed88d4d944948c')
    addScriptToBody('//jspassport.ssl.qhimg.com/11.0.1.js?d182b3f28525f2db83acfaaf6e696dba')
    if (window.location.protocol === 'https:') {
      addScriptToBody('//zz.bdstatic.com/linksubmit/push.js')
    } else {
      addScriptToBody('//push.zhanzhang.baidu.com/push.js')
    }
  }
}
